export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home-link",
  marketplace: "nav-marketplace-link",
  registry: "nav-registry-link",
  cta: "nav-cta-button",
};

export const LANDING = {
  hero: "landing-hero",
  ctaPrimary: "landing-cta-primary",
  ctaSecondary: "landing-cta-secondary",
  coreMessage: "landing-core-message",
};

export const ONBOARDING = {
  root: "onboarding-root",
  step1: "onboarding-step-1",
  step2: "onboarding-step-2",
  step3: "onboarding-step-3",
  dueDateTrigger: "onboarding-due-date-trigger",
  locationSelect: "onboarding-location-select",
  locationOption: (loc) => `onboarding-location-option-${loc}`,
  priorityCheckbox: (id) => `onboarding-priority-${id}`,
  next: "onboarding-next-button",
  back: "onboarding-back-button",
  finish: "onboarding-finish-button",
};

export const DASHBOARD = {
  root: "dashboard-root",
  viewToggle: "dashboard-view-toggle",
  motherView: "dashboard-mother-view",
  guestView: "dashboard-guest-view",
  marketplaceCard: (id) => `marketplace-card-${id}`,
  addBtn: (id) => `add-to-registry-${id}`,
  removeBtn: (id) => `remove-from-registry-${id}`,
  registryItem: (id) => `registry-item-${id}`,
  contributeBtn: (id) => `contribute-btn-${id}`,
  contributeConfirm: "contribute-confirm-button",
  contributeModal: "contribute-modal",
  comingSoonBanner: "coming-soon-banner",
  localCareHub: "local-care-hub",
  nationwide: "nationwide-collection",
  motherRegistry: "mother-registry",
};
